// extracted by mini-css-extract-plugin
export default {"label":"DatosAsignaturas_label__e7G4j","title":"DatosAsignaturas_title__fA8bX","content":"DatosAsignaturas_content__1eaQt","placeholder":"DatosAsignaturas_placeholder__uvMlj"};